import { ModalProps } from "components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import SearchBar from "./SearchBar";
import SearchTable from "./SearchTable";
import { epdSearchStore } from "store/Mapping/EPDSearchStore";
import { observer } from "mobx-react-lite";
import Badge from "components/Badge";
import { IconTrashX } from "@tabler/icons-react";

interface ProductEditorEPDSearch extends ModalProps {
  datasetIndex: number;
  rowIndex: number;
  closeEPDSearch: () => void;
  searchTerm?: string;
}

const EPDSearch2050 = (props: ProductEditorEPDSearch) => {
  const { i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const [term, setTerm] = React.useState<string>("");

  React.useEffect(() => {
    setTerm(props.searchTerm ?? "");
  }, [props.searchTerm]);

  const onSearch = (value: string | number) => setTerm(String(value));

  const onRemoveFilter = (categoryId: string | number | undefined) => {
    const filteredItems = epdSearchStore.selectedFilters.filter(
      (rec) => rec.category.id !== categoryId
    );
    epdSearchStore.setSelectedFilters(filteredItems);
  };

  return (
    <>
      <SearchBar value={term} onChange={onSearch} open={props.open} />
      <div className="flex gap-4 mb-3 flex-wrap items-center">
        {epdSearchStore.selectedFilters.map((rec) => (
          <Badge
            closable
            key={rec.category.id}
            type="auto"
            className="!h-6 !mb-0"
            onClose={() => onRemoveFilter(rec.category.id)}
          >
            <span className="font-semibold">
              {isEng ? rec.category.name : rec.category.name_de}:
            </span>
            <span className="mx-1">
              {rec.items
                .map((item) => (isEng ? item.name : item.name_de))
                .join(", ")}
            </span>
          </Badge>
        ))}
        {epdSearchStore.selectedFilters.length > 0 && (
          <IconTrashX
            className="text-gray-700 cursor-pointer"
            size={20}
            stroke={2}
            onClick={() => epdSearchStore.setSelectedFilters([])}
          />
        )}
      </div>
      <SearchTable
        term={term}
        datasetIndex={props.datasetIndex}
        rowIndex={props.rowIndex}
        close={props.closeEPDSearch}
      />
    </>
  );
};

export default observer(EPDSearch2050);
